import RegisterContainer from "./RegisterContainer";
import WellcomeContainer from "./WellcomeContainer";
function WellcomeSucces() {
    return (
        <RegisterContainer verify>
            <WellcomeContainer
                back={'/register/verify-token'}
                title={'Đăng ký thành công'}
                description={'Vui lòng chờ quản trị viên phê duyệt tài khoản của bạn'}
            />
        </RegisterContainer>
    )
}

export default WellcomeSucces;